import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { generateSelfServiceToken } from '../../api/selfService'

export const checkSelfServiceAccess = createAsyncThunk(
  'selfService/checkAccess',
  async () => {
    const response = await generateSelfServiceToken()
    return response?.success === true
  }
)

const selfServiceSlice = createSlice({
  name: 'selfService',
  initialState: {
    enabled: false,
    loading: false,
  },
  reducers: {
    setSelfServiceEnabled: (state, action) => {
      state.enabled = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(checkSelfServiceAccess.pending, state => {
        state.loading = true
      })
      .addCase(checkSelfServiceAccess.fulfilled, (state, action) => {
        state.enabled = action.payload
        state.loading = false
      })
      .addCase(checkSelfServiceAccess.rejected, state => {
        state.enabled = false
        state.loading = false
      })
  },
})

export const { setSelfServiceEnabled } = selfServiceSlice.actions
export default selfServiceSlice.reducer
